{
  "recommendationAccepted": null,
  "numberOfDocumentsRequested": 0,
  "setCompletionDateForEmail": "",
  "opportunityOwnerTextForEmail": "Lewis Kinsella",
  "ownerEmailAddress": "lewis.kinsella@mojomortgages.com",
  "flexRoles2": "Mortgage Expert",
  "mipIssuedToCustomer": true,
  "amount": null,
  "stageName": "Nurture",
  "opportunityRecordType1": "PurchaseOpportunity",
  "property": {
    "firstLineAddress": "123 Fake Street",
    "value": 375000
  }
}